export default __webpack_public_path__ + "static/media/EngineeringRoads_07.ddbcd0ca.png";